import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { Card, CardBody, Col, Row, Button, Spinner } from "reactstrap";
import { confirmPublisherOnboarding } from "./service";
import logo from "../../assets/img/illustrations/falcon.png";

const ConfirmPublisher = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [publisherName, setPublisherName] = useState("");
  const [countdown, setCountdown] = useState(3);

  const queryParams = new URLSearchParams(window.location.search);
  const pubid = queryParams.get("pubid");

  useEffect(() => {
    document.querySelectorAll(".navbar-vertical").forEach((el) => {
      el.style.display = "none";
    });
    document.querySelectorAll(".navbar-glass").forEach((el) => {
      el.style.display = "none";
    });

    if (!pubid) {
      setError("Invalid or missing publisher ID.");
      setLoading(false);
      return;
    }

    let isMounted = true;

    (async () => {
      try {
        const res = await confirmPublisherOnboarding(pubid);
        if (!isMounted) return;

        if (res && res.success) {
          setPublisherName(res.publisherName || `Publisher #${pubid}`);
          setSuccess(true);
          setLoading(false);
        } else {
          setError(res?.message || "Failed to confirm publisher onboarding.");
          setLoading(false);
        }
      } catch (err) {
        if (!isMounted) return;
        const msg = err.response?.data?.message || err.message || "An error occurred during confirmation.";
        setError(msg);
        setLoading(false);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [pubid]);

  const isLoged = localStorage.getItem("isLoged") === "true";

  const handleRedirectNow = () => {
    if (isLoged) {
      window.location.href = "/";
    } else {
      window.location.href = "/login";
    }
  };

  useEffect(() => {
    if (!success && !error) return;

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          handleRedirectNow();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [success, error]);

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-holder">
      <Row className="justify-content-center w-100">
        <Col xs="12" sm="10" md="7" lg="5" xl="4">
          <Card className="text-center shadow-lg border-0">
            <CardBody className="p-4 p-sm-5">
              <img src={logo} alt="Logo" width="58" className="mb-3" />

              {loading && (
                <div>
                  <div className="my-4">
                    <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
                  </div>
                  <h4 className="font-weight-bold mb-2">Verifying Publisher Onboarding</h4>
                  <p className="text-muted fs--1 mb-0">
                    Please wait while we verify details and confirm publisher account access...
                  </p>
                </div>
              )}

              {!loading && success && (
                <div>
                  <div className="my-3">
                    <span className="badge badge-soft-success p-3 rounded-circle">
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                    </span>
                  </div>
                  <h4 className="text-success font-weight-bold mb-2">Onboarding Confirmed!</h4>
                  <p className="text-600 mb-4">
                    Onboarding for <strong>{publisherName}</strong> has been successfully confirmed and full dashboard access is granted.
                  </p>
                  <div className="alert alert-success py-2 px-3 mb-4 fs--1">
                    Auto-redirecting to {isLoged ? "dashboard" : "login"} in {countdown}s...
                  </div>
                  <Button block color="primary" onClick={handleRedirectNow}>
                    {isLoged ? "Go to Dashboard" : "Go to Login"}
                  </Button>
                </div>
              )}

              {!loading && error && (
                <div>
                  <div className="my-3">
                    <span className="badge badge-soft-danger p-3 rounded-circle">
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                      </svg>
                    </span>
                  </div>
                  <h4 className="text-danger font-weight-bold mb-2">Verification Failed</h4>
                  <p className="text-muted mb-4 fs--1">{error}</p>
                  <Button block color="secondary" onClick={handleRedirectNow}>
                    {isLoged ? "Return to Dashboard" : "Go to Login"}
                  </Button>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default withRouter(ConfirmPublisher);
